import { FileData } from '@/types/asset';
import AssetCrud from '@/classes/AssetCrud';
import { FieldNormalizer } from '../types';

export default class FileInputNormalizer implements FieldNormalizer {
  async normalize(value: any): Promise<FileData|null> {
    return AssetCrud.getAsset(value);
  }

  async reverseNormalize(file: any): Promise<number|null> {
    return AssetCrud.createAsset(file);
  }
}
